import type { AdvancedSchedulingValues } from '../../../../components/advanced-scheduling-section/AdvancedSchedulingSection.types';

export interface AdvancedSchedulingPayloadOverlay {
  timeSlot?: { startDate: Date | string; endDate: Date | string };
  exclusionDates?: Date[];
  deploymentsPerDay?: number;
  exclusionDays?: string[];
}

function hhmmToDate(hhmm: string): Date {
  const [h, m] = hhmm.split(':').map((n) => Number.parseInt(n, 10));
  const d = new Date();
  d.setHours(h, m, 0, 0);
  return d;
}

function isoDateStringToDate(iso: string): Date {
  return new Date(`${iso}T00:00:00.000Z`);
}

export function mapAdvancedSchedulingToPayload(
  values: AdvancedSchedulingValues | undefined,
): AdvancedSchedulingPayloadOverlay {
  if (!values) return {};
  const overlay: AdvancedSchedulingPayloadOverlay = {};

  if (typeof values.deploymentsPerDay === 'number') {
    overlay.deploymentsPerDay = values.deploymentsPerDay;
  }

  if (values.timeSlot?.start && values.timeSlot?.end) {
    const startDate =
      values.timeSlot?.start instanceof Date ? values.timeSlot?.start : hhmmToDate(values.timeSlot?.start);
    const endDate = values.timeSlot?.end instanceof Date ? values.timeSlot?.end : hhmmToDate(values.timeSlot?.end);

    overlay.timeSlot = {
      startDate,
      endDate,
    };
  }

  if (values.exclusionDays && values.exclusionDays.length > 0) {
    overlay.exclusionDays = [...values.exclusionDays];
  }

  if (values.exclusionDates && values.exclusionDates.length > 0) {
    const filtered = values.exclusionDates.filter((d) => d !== '');
    if (filtered.length > 0) {
      overlay.exclusionDates = filtered.map(isoDateStringToDate);
    }
  }

  return overlay;
}
